import { screeningExclusionText } from "../screeningCopy"
import { BackIcon, Box, ForwardIcon, Link, Typography } from "@carrotfertility/carotene-core"
import React from "react"

type NotEligiblePageProps = {
  // The exclusion-message id the BFF passed (screening disqualification or the known-data gate);
  // resolved to copy via screeningExclusionText. Absent/"" falls through to the single default.
  exclusionMessageId?: string | null
  // Navigates to Carrot Academy's care options (host-provided). The design's "resources below" link.
  onExploreCareOptions?: () => void
  // Returns to the health-questions step. Provided ONLY when the member was disqualified by the
  // screener — never for a known-data refusal, so re-answering can't bypass the eligibility gate.
  onBackToQuestions?: () => void
}

// The single not-eligible page (design: 412-1381). One static heading; the body is whichever
// exclusion message the BFF passed (one message defined today). The medical-emergency 911 guidance
// lives in that copy, not as a screening question. TEMPORARY (OPS-9280): pending final design polish.
const HEADING = "Sorry. We're unable to support you at this time."

export function NotEligiblePage({
  exclusionMessageId,
  onExploreCareOptions,
  onBackToQuestions
}: NotEligiblePageProps): JSX.Element {
  const message = screeningExclusionText(exclusionMessageId ?? "")

  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(theme.tokens.spacing.md),
        maxInlineSize: 640
      })}
    >
      <Typography variant="h1">{HEADING}</Typography>
      <Box
        sx={(theme) => ({
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: theme.spacing(theme.tokens.spacing.xl)
        })}
      >
        <Typography variant="body1">{message}</Typography>
        {onExploreCareOptions && (
          <Link
            component="button"
            type="button"
            onClick={onExploreCareOptions}
            sx={(theme) => ({
              display: "inline-flex",
              alignItems: "center",
              gap: theme.spacing(theme.tokens.spacing.xxs)
            })}
          >
            Explore care options on Carrot Academy
            <ForwardIcon fontSize="small" />
          </Link>
        )}
        {onBackToQuestions && (
          <Link
            component="button"
            type="button"
            underline="hover"
            onClick={onBackToQuestions}
            sx={(theme) => ({
              display: "inline-flex",
              alignItems: "center",
              gap: theme.spacing(theme.tokens.spacing.xxs)
            })}
          >
            <BackIcon fontSize="small" />
            Back to questions
          </Link>
        )}
      </Box>
    </Box>
  )
}
